import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * HTTP Error Interceptor
 * Catches API errors and displays user-friendly messages.
 * Particularly important for team access errors which previously failed silently.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Don't show snackbar for certain endpoints that handle their own errors
        const silentEndpoints = ['/api/mux/', '/mux/'];
        const isSilent = silentEndpoints.some(ep => req.url.includes(ep));

        if (!isSilent && error.status === 403) {
          const errorBody = error.error;
          let message = 'Access denied';

          if (errorBody?.code === 'NO_TEAM_MEMBERSHIP') {
            message = errorBody.error || 'You are not a member of any teams. Please contact your administrator.';
          } else if (errorBody?.code === 'TEAM_ACCESS_DENIED') {
            message = errorBody.error || 'You do not have access to this team.';
          } else if (errorBody?.error) {
            message = errorBody.error;
          }

          this.snackBar.open(message, 'Dismiss', {
            duration: 10000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        }

        if (!isSilent && error.status === 401) {
          this.snackBar.open('Your session has expired. Please log in again.', 'Dismiss', {
            duration: 10000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        }

        return throwError(() => error);
      })
    );
  }
}
